var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enabled
    ? _c("div", [
        _c("h4", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "category-filter" },
          [
            _c("select-dropdown", {
              attrs: { items: _vm.listItems, name: _vm.filter.filterBy },
              model: {
                value: _vm.selectedFilter,
                callback: function ($$v) {
                  _vm.selectedFilter = $$v
                },
                expression: "selectedFilter",
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }